import * as notifier from './notifier.js';
import * as loader from './loader.js';
import * as marketplace from '../xhr/marketplace.js';
import * as types from './types/marketplace.js';
import { i18n, tokens } from '@simplybenefits/sb-ui-library';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'full') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 * @param product
 * @param volume
 * @param member
 * @param entityType
 */
export function getRate(product, volume, member, entityType = 'primary') {
    return marketplace
        .getRate(product.productID, {
            volume,
            entityType,
            pricing: product.pricing,
            ratesType: product.ratesType,
            commissionPercentage: product.commissionPercentage,
            markup: product.markup,
            coverageType: member.coverageType,
            birthdate: member.birthdate,
            isSmoker: Boolean(member.isSmoker),
            hasDependentSmoker: Boolean(member.hasDependentSmoker),
            gender: member.gender
        })
        .then((data) => data.rate)
        .catch((error) => {
            console.log(error);
        });
}

/**
 * @returns {function(*=): Promise<any | never>}
 */
export function getProduct(productID) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return marketplace
            .getProduct(productID)
            .then((data) => {
                setLoader(dispatch, false);
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 * @returns {function(*): Promise<*>}
 */
export function purchaseProduct(purchaseData) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return marketplace
            .purchaseProduct(purchaseData)
            .then((data) => {
                dispatch({
                    type: types.SET_PRODUCTS,
                    data
                });

                setLoader(dispatch, false);
                dispatch(notifier.displayMessage(i18n.t(tokens.labels.notifications.purchaseCompletedSuccessfully)));
                return true;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param productID
 * @param failedKnockOutQuestions
 * @returns {function(*): *}
 */
export function blockProductCoverage(productID, failedKnockOutQuestions) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return marketplace
            .blockProductCoverage(productID, failedKnockOutQuestions)
            .then((coverageTypesBlocked) => {
                setLoader(dispatch, false);
                return coverageTypesBlocked;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param productID
 * @param signage
 * @param password
 */
export function terminateProduct(productID, signage, password) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return marketplace
            .terminateProduct(productID, signage, password)
            .then(() => {
                setLoader(dispatch, false);
                dispatch(notifier.displayMessage(i18n.t(tokens.labels.notifications.productTerminatedSuccessfully)));

                setTimeout(() => {
                    window.location.reload();
                }, 2000);

                return true;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param productID
 * @returns {function(*): Promise<boolean>}
 */
export function optIn(productID) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return marketplace
            .optIn(productID)
            .then(() => {
                setLoader(dispatch, false);
                return true;
            })
            .catch((error) => {
                console.log(error);
                setLoader(dispatch, false);
                notifier.displayError(error);
                return false;
            });
    };
}

/**
 * @param productID
 * @param signage
 * @param password
 * @returns {function(*): Promise<boolean>}
 */
export function optOut(productID, signage, password) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return marketplace
            .optOut(productID, signage, password)
            .then(() => {
                dispatch({
                    type: types.REMOVE_PRODUCT,
                    productID
                });

                setLoader(dispatch, false);
                dispatch(notifier.displayMessage(i18n.t(tokens.labels.notifications.productDeclined)));

                return true;
            })
            .catch((error) => {
                console.log(error);
                setLoader(dispatch, false);
                notifier.displayError(error);
                return false;
            });
    };
}